<script>
export default {
  computed: {
    notDesktop() {
      return (
        this.$vuetify?.breakpoint.sm ||
        this.$vuetify?.breakpoint.xs ||
        this.$vuetify?.breakpoint.md
      )
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
  },
}
</script>
